import React from 'react'

import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'

type Props = {
  to: string
}

export const HistoryLink: React.FC<Props & React.HTMLAttributes<HTMLElement>> =
  ({ to, children, className }) => {
    const location = useLocation()

    return (
      <Link
        to={to}
        state={{ prevPath: location.pathname + location.search }}
        className={className}
      >
        {children}
      </Link>
    )
  }
